import { CsFaIcons, CsIconClasses, CsImages } from '@app/shared/cs-components/cs-images.';
import * as moment from 'moment';
import * as i0 from "@angular/core";
var CsActivityLogFilterConfigService = /** @class */ (function () {
    function CsActivityLogFilterConfigService() {
        this.mappedFilterConfigList = [];
        // Config Data :
        this.ISODateFormat = 'YYYY-MM-DD';
        this.dateSeparator = ':';
        this.existingAppliedFilters = {};
        this.recordConfig = {
            new_email: { type: 'EMAIL', iconSrc: CsFaIcons.email },
            new_sms: { type: 'SMS', iconSrc: CsFaIcons.sms },
            new_phone_call: { type: 'CALL', iconSrc: CsFaIcons.call },
            new_note: { type: 'NOTE', iconSrc: CsFaIcons.note },
            schedule_activity: { type: 'SCHEDULE_ACTIVITY', iconSrc: CsFaIcons.taskList }
        };
    }
    CsActivityLogFilterConfigService.prototype.getDdFilterConfigList = function (filterDataList) {
        var _this = this;
        this.mappedFilterConfigList = [];
        if (filterDataList) {
            filterDataList.forEach(function (filterItem) {
                // switch (item['identifier']) {
                if (filterItem['filters'] && filterItem['filters'].length) {
                    switch (filterItem['template_identifier']) {
                        case 'date_range':
                            // this.prepareDateRangeFilter(item);
                            _this.mappedFilterConfigList.push(_this.prepareDateRangeFilter(filterItem));
                            break;
                        case 'record_type':
                            // this.prepareRecordTypeFilter(item);
                            _this.mappedFilterConfigList.push(_this.prepareRecordTypeFilter(filterItem));
                            break;
                        case 'user':
                            // this.prepareUserFilter(item);
                            _this.mappedFilterConfigList.push(_this.prepareUserFilter(filterItem));
                            break;
                        case 'object':
                            // this.prepareModuleFilter(item);
                            _this.mappedFilterConfigList.push(_this.prepareModuleFilter(filterItem));
                            break;
                    }
                }
            });
        }
        // return [
        //     this.dateRangeFilter,
        //     this.recordTypeFilter,
        //     this.userFilter,
        //     this.moduleFilter
        // ];
        return this.mappedFilterConfigList;
    };
    CsActivityLogFilterConfigService.prototype.getDdControlConfigList = function (controls) {
        this.prepareAddRecordControl(controls);
        return [
            this.addRecord
        ];
    };
    // Prepare drop-down Filters' config :
    CsActivityLogFilterConfigService.prototype.prepareDateRangeFilter = function (filter) {
        var _this = this;
        if (filter['filters']['length']) {
            filter['filters'].unshift({
                name: 'All days',
                selected: false,
                show: true,
                uniq_identifier: '',
                identifier: 'all_days'
            });
        }
        this.dateRangeFilter = {
            id: filter['identifier'],
            ddTogglerConfig: {
                templateType: 'BTN_TRANSPARENT',
                templateData: { text: filter['name'] }
            },
            ddMenuConfig: {
                isSearchBar: true,
                templateType: 'BASIC',
                items: filter['filters'].map(function (item) {
                    _this.setDateRange(item);
                    var mappedItem = {
                        id: item['uniq_identifier'],
                        filterId: item['uniq_identifier'],
                        ddConfigId: filter['identifier'],
                        isSelected: item['selected'],
                        isPicker: item['isPicker'] || null,
                        pickerConfig: {
                            _config: {
                                showWeekNumbers: false,
                                minDate: item['minDate'] || null,
                                maxDate: item['maxDate'] || null
                            },
                            placement: 'right'
                        },
                        pickerType: item['pickerType'] || null,
                        templateData: {
                            text: item['name']
                        }
                    };
                    _this.setExistingAppliedFilters(mappedItem);
                    return mappedItem;
                })
            }
        };
        return this.dateRangeFilter;
    };
    CsActivityLogFilterConfigService.prototype.prepareRecordTypeFilter = function (filter) {
        var _this = this;
        this.recordTypeFilter = {
            id: filter['identifier'],
            ddTogglerConfig: {
                templateType: 'BTN_TRANSPARENT',
                templateData: { text: filter['name'] }
            },
            ddMenuConfig: {
                templateType: 'BASIC',
                isGroupItem: true,
                isMultiChoice: true,
                groupItems: (function () {
                    var groupObj = {};
                    filter['filters'].forEach(function (item) {
                        if (!groupObj[item['type']]) {
                            groupObj[item['type']] = {
                                id: item['type'],
                                title: item['type'],
                                items: []
                            };
                        }
                        groupObj[item['type']]['items'].push((function () {
                            var mappedItem = {
                                id: item['uniq_identifier'],
                                filterId: item['uniq_identifier'],
                                ddConfigId: filter['identifier'],
                                isSelected: item['selected'],
                                templateData: {
                                    text: item['name'],
                                    iconsList: [
                                        _this.getIconConfig('check_box', CsIconClasses.squareCheckBox, false, 'CLASS_ICON'),
                                    ]
                                }
                            };
                            _this.setExistingAppliedFilters(mappedItem, true);
                            return mappedItem;
                        })());
                    });
                    return Object.values(groupObj);
                })()
            }
        };
        return this.recordTypeFilter;
    };
    CsActivityLogFilterConfigService.prototype.prepareUserFilter = function (filter) {
        var _this = this;
        if (filter['filters']['length']) {
            filter['filters'].unshift({
                name: 'All users',
                selected: false,
                show: true,
                uniq_identifier: '',
                profile: '',
                identifier: ''
            });
        }
        this.userFilter = {
            id: filter['identifier'],
            ddTogglerConfig: {
                templateType: 'BTN_TRANSPARENT',
                templateData: { text: filter['name'] }
            },
            ddMenuConfig: {
                templateType: 'BASIC',
                isSearchBar: true,
                items: filter['filters'].map(function (item) {
                    var mappedItem = {
                        id: item['uniq_identifier'],
                        filterId: item['uniq_identifier'],
                        ddConfigId: filter['identifier'],
                        isSelected: item['selected'],
                        templateData: {
                            text: item['name'],
                            iconsList: [
                                (function () { return _this.getIconConfig('profile_pic', item['profile'] || CsImages.userProfile, false, 'IMAGE', 'CIRCLE'); })()
                            ]
                        }
                    };
                    _this.setExistingAppliedFilters(mappedItem);
                    return mappedItem;
                })
            }
        };
        return this.userFilter;
    };
    CsActivityLogFilterConfigService.prototype.prepareModuleFilter = function (filter) {
        var _this = this;
        this.moduleFilter = {
            id: filter['identifier'],
            ddTogglerConfig: {
                templateType: 'BTN_TRANSPARENT',
                templateData: { text: filter['name'] }
            },
            ddMenuConfig: {
                templateType: 'BASIC',
                items: filter['filters'].map(function (item) {
                    var mappedItem = {
                        id: item['uniq_identifier'],
                        filterId: item['uniq_identifier'],
                        ddConfigId: filter['identifier'],
                        isSelected: item['selected'],
                        templateData: {
                            text: item['name']
                        }
                    };
                    _this.setExistingAppliedFilters(mappedItem);
                    return mappedItem;
                })
            }
        };
        return this.moduleFilter;
    };
    // Prepare drop-down Controls' config :
    CsActivityLogFilterConfigService.prototype.prepareAddRecordControl = function (controlList) {
        var _this = this;
        this.addRecord = {
            id: 'add_record',
            ddTogglerConfig: {
                templateType: 'BTN_PRIMARY',
                togglerType: 'SOLID',
                templateData: {
                    text: 'Add record'
                }
            },
            ddMenuConfig: {
                templateType: 'BASIC',
                isMultiChoice: true,
                gridColumns: 2,
                items: (function () {
                    return controlList.map(function (record) {
                        if (_this.recordConfig[record['identifier']]) {
                            return {
                                id: record['identifier'],
                                type: _this.recordConfig[record['identifier']].type,
                                isDisableItemClick: true,
                                isFavourite: record['favorite'],
                                templateData: (function () {
                                    return {
                                        text: record['name'],
                                        isTextClick: true,
                                        isDdMenuHide: true,
                                        iconsList: [
                                            _this.getIconConfig("fav", record['favorite'] ? CsFaIcons.starSolid : CsFaIcons.starRegular, true, 'FA_ICON', 'BOX', false, true),
                                            _this.getIconConfig(record.id + "_icon", _this.recordConfig[record['identifier']].iconSrc, false, 'FA_ICON', 'BOX', true)
                                        ]
                                    };
                                })()
                            };
                        }
                    }).filter(function (item) { return item; });
                })()
            }
        };
    };
    // Helper functions :
    CsActivityLogFilterConfigService.prototype.getIconConfig = function (iconId, iconSrc, isIconClick, srcType, shape, isItemIndicator, isFavIndicator) {
        if (isIconClick === void 0) { isIconClick = false; }
        if (srcType === void 0) { srcType = 'FA_ICON'; }
        if (shape === void 0) { shape = 'BOX'; }
        if (isItemIndicator === void 0) { isItemIndicator = false; }
        if (isFavIndicator === void 0) { isFavIndicator = false; }
        return ({
            id: iconId,
            src: iconSrc,
            type: srcType,
            shape: shape,
            isIconClick: isIconClick,
            isFavouriteIndicator: isFavIndicator,
            isItemIndicator: isItemIndicator
        });
    };
    CsActivityLogFilterConfigService.prototype.setExistingAppliedFilters = function (filterItem, isMultiChoice) {
        if (filterItem.isSelected) {
            if (this.existingAppliedFilters[filterItem.ddConfigId]) {
                if (isMultiChoice) {
                    this.existingAppliedFilters[filterItem.ddConfigId].push(filterItem.filterId);
                }
                else {
                    this.existingAppliedFilters[filterItem.ddConfigId] = [filterItem.filterId];
                }
            }
            else {
                this.existingAppliedFilters[filterItem.ddConfigId] = [filterItem.filterId];
            }
        }
    };
    CsActivityLogFilterConfigService.prototype.getExistingAppliedFilters = function () {
        return this.existingAppliedFilters;
    };
    CsActivityLogFilterConfigService.prototype.setDateRange = function (item) {
        var currentDate = Date.now(), itemId = item['identifier'].toLowerCase();
        // let fromDt, toDt;
        // Note: Here `item['identifier']` comes from API, So handled cases according that.
        switch (itemId) {
            // case 'today' :
            //     item['filterId'] = item['uniq_identifier'] + `_${moment(currentDate).format(this.ISODateFormat)}`;
            //     break;
            // case 'yesterday' :
            //     item['filterId'] = item['uniq_identifier'] + `_${moment(currentDate).subtract(1, 'day').format(this.ISODateFormat)}`;
            //     break;
            // case 'tomorrow' :
            //     item['filterId'] = item['uniq_identifier'] + `_${moment(currentDate).add(1, 'day').format(this.ISODateFormat)}`;
            //     break;
            // case 'this_week' :
            //     fromDt = moment(currentDate).subtract(0, 'weeks').startOf('week').format(this.ISODateFormat);
            //     toDt = moment(currentDate).subtract(0, 'weeks').endOf('week').format(this.ISODateFormat);
            //
            //     item['filterId'] = item['uniq_identifier'] + '_' + fromDt + this.dateSeparator + toDt;
            //     break;
            // case 'last_week' :
            //     fromDt = moment(currentDate).subtract(1, 'weeks').startOf('week').format(this.ISODateFormat);
            //     toDt = moment(currentDate).subtract(1, 'weeks').endOf('week').format(this.ISODateFormat);
            //
            //     item['filterId'] = item['uniq_identifier'] + '_' + fromDt + this.dateSeparator + toDt;
            //     break;
            // case 'last_month' :
            //     fromDt = moment(currentDate).subtract(1, 'months').startOf('month').format(this.ISODateFormat);
            //     toDt = moment(currentDate).subtract(1, 'months').endOf('month').format(this.ISODateFormat);
            //
            //     item['filterId'] = item['uniq_identifier'] + '_' + fromDt + this.dateSeparator + toDt;
            //     break;
            // case 'last_quarter' :
            //     const quarterMonth = (moment().month() % 3) + 1;
            //     const lastQuarterEndDate = moment().subtract({months: quarterMonth}).endOf('month');
            //     const lastQuarterStartDate = lastQuarterEndDate.clone().subtract({months: 3}).startOf('month').format(this.ISODateFormat);
            //
            //     fromDt = lastQuarterStartDate;
            //     toDt = lastQuarterEndDate.format(this.ISODateFormat);
            //
            //     item['filterId'] = item['uniq_identifier'] + '_' + fromDt + this.dateSeparator + toDt;
            //     break;
            // case 'last_year' :
            //     fromDt = moment(currentDate).subtract(1, 'year').startOf('year').format(this.ISODateFormat);
            //     toDt = moment(currentDate).subtract(1, 'year').endOf('year').format(this.ISODateFormat);
            //
            //     item['filterId'] = item['uniq_identifier'] + '_' + fromDt + this.dateSeparator + toDt;
            //     break;
            case 'bt_':
                item['isPicker'] = true;
                item['pickerType'] = 'DATE_RANGE';
                break;
            case 'before_':
            case 'after_':
                item['isPicker'] = true;
                item['pickerType'] = 'DATE';
                item[itemId === 'before_' ? 'maxDate' : 'minDate'] = new Date();
                break;
        }
    };
    CsActivityLogFilterConfigService.prototype.doPickerAction = function (data) {
        switch (data.type) {
            case 'DATE':
                data.item.filterId = data.item.id + moment(data.val).format(this.ISODateFormat);
                break;
            case 'DATE_RANGE':
                var fromDt = moment(data.val[0]).format(this.ISODateFormat);
                var toDt = moment(data.val[1]).format(this.ISODateFormat);
                data.item.filterId = data.item.id + fromDt + this.dateSeparator + toDt;
                break;
        }
    };
    CsActivityLogFilterConfigService.prototype.resetExistingAppliedFilters = function () {
        this.existingAppliedFilters = {};
    };
    CsActivityLogFilterConfigService.ngInjectableDef = i0.defineInjectable({ factory: function CsActivityLogFilterConfigService_Factory() { return new CsActivityLogFilterConfigService(); }, token: CsActivityLogFilterConfigService, providedIn: "root" });
    return CsActivityLogFilterConfigService;
}());
export { CsActivityLogFilterConfigService };
